import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { selectContentTotalLength } from '../../selectors/ContentSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { AllSchedulesSpace, AllSchedulesSpaceDispatchProps, AllSchedulesSpaceOwnProps, AllSchedulesSpaceStateProps } from './AllSchedulesSpace';

const mapStateToProps: MapStateToProps<AllSchedulesSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedSchedules: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<AllSchedulesSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
}, dispatch);

export const ConnectedAllSchedulesSpace: React.ComponentClass<AllSchedulesSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllSchedulesSpace);
